/* ------------------------------------------------------------------------------
@name: Product
--------------------------------------------------------------------------------- */

// --- variables
import { API_URL, WEB_URL } from "variables";

// --- utilities
import { Form, Session, HttpRequest, SweetAlert } from "utilities";

const Product = (() => {
  // handlerGetProduct
  const handlerGetProduct = (search = 0, callback = null) => {
    $.ajax({
      url: API_URL.productGet,
      method: "POST",
      dataType: "JSON",
      data: {
        search: search,
      },
      success: (response) => {
        const _data = response.data || [];

        let _content = "";
        $.each(_data, (i, v) => {
          _content += `<li class="form-dropdown-item">
                        <span class="form-dropdown-select" data-value="${v.name}" data-id="${v.id}">
                          ${v.name}
                        </span>
                      </li>`;
        });

        _content += `<li class="form-dropdown-notif">
                      <button type="button" class="btn btn-block btn-custom waves-effect waves-light form-dropdown-btn js-add-input-product">
                        Tambah <i class="mdi mdi-plus-circle"></i>
                      </button>
                    </li>`;

        $(".js-list-product").html(_content);

        if (typeof callback === "function") {
          callback();
        }
      },
      error: () => {
        $(".js-list-product").html(
          `<li class="form-dropdown-notif">
            <button type="button" class="btn btn-block btn-custom waves-effect waves-light form-dropdown-btn js-add-input-product">
              Tambah <i class="mdi mdi-plus-circle"></i>
            </button>
          </li>`
        );

        if (typeof callback === "function") {
          callback();
        }
      },
    });
  };

  // handlerAddInputProduct
  const handlerAddInputProduct = () => {
    $("body").on("click", ".js-add-input-product", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $this = $(this);
      const $dropdown = $this.closest(".form-dropdown");
      const $row = $this.closest(".js-row-product");
      const $input = $row.find(".js-input-product");
      const value = ($input.val() || "").trim();

      if (!value) {
        SweetAlert.error("Warning", "Please enter product name first.");
        $input.focus();
        return;
      }

      $this.prop("disabled", true);

      $.ajax({
        url: API_URL.productAdd,
        method: "POST",
        dataType: "JSON",
        data: {
          product_name: value,
        },
        success: (result) => {
          if (result.code === 200 || result.code === 409) {
            const productId = result.data?.id || "";
            const productName = result.data?.name || value;

            $input.val(productName);
            $input.attr("data-id", productId);

            handlerGetProduct(0, () => {
              $dropdown.addClass("show");
              $dropdown.find(".js-list-product").show();
              $dropdown.find(".form-dropdown-notif").hide();
            });
          } else {
            SweetAlert.error(
              "Error",
              result.message || "Failed to add product."
            );
          }
        },
        error: (xhr) => {
          console.error(xhr);
          SweetAlert.error(
            "Error",
            "Something went wrong while adding product."
          );
        },
        complete: () => {
          $this.prop("disabled", false);
        },
      });
    });
  };

  // init
  const init = () => {
    if ($(".js-list-product").length) {
      handlerGetProduct();
    }

    handlerAddInputProduct();
  };

  return {
    init,
  };
})();

export default Product;
